import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output, booleanAttribute } from "@angular/core";

@Component({
  selector: "bs-listings-detail-booking-widget",
  templateUrl: "./booking-widget.component.html",
  styleUrls: ["./booking-widget.component.scss"],
})
export class BsListingsDetailBookingWidgetComponent implements OnInit {
  @Input({ required: true }) thirdpartyAccountId;
  @Input({ required: true }) listingId;
  @Input({ required: true }) enabled;
  @Input()
  set widgetUrl(value) {
    if (value) {
      this.code = `<iframe src="${value}" frameborder="0" width="100%" style="min-height: 800px"></iframe>`;
    }
  }
  @Output() onUpdated = new EventEmitter();

  code;
  previewVisible = false;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    // this.initBookingWidgetCode();
  }

  onStatusChange(value) {
    console.log("change: ", value);
    this.requestUpdateEnableStatus(value);
  }

  private requestUpdateEnableStatus(status) {
    const params = {
      thirdparty_account_id: this.thirdpartyAccountId,
      listing_id: this.listingId,
      is_listed: status ? 1 : 0,
    };
    this.http.post("/api/bs/listings/set_listed", params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.onUpdated.emit();
      } else {
        this.enabled = !status;
      }
    });
  }

  private initBookingWidgetCode() {
    const origin =
      location.href.includes(".test") || location.href.includes("localhost")
        ? `//bs${this.thirdpartyAccountId}.xiaogechuangxin.com`
        : `//bookingsite-app${this.thirdpartyAccountId}.hostex.io`;
    // const bsUrl = `${origin}/widget/check?listing_id=${this.listingId}&enabled=${this.enabled}`;
    const bsUrl = `${origin}/widget/check?listing_id=${this.listingId}&enabled=${this.enabled}`;
    this.code = `<iframe src="${bsUrl}" frameborder="0" width="100%" style="min-height: 800px"></iframe>`;

    console.log("code: ", this.code);
  }
}
